import React from 'react'
import Button from './Button'

const ButtonList = () => {
  return (
    <div className='ml-10'>
      <Button/>
    </div>
  )
}

export default ButtonList
